<template>
    <div>
        <div class="FilterTitle">{{ Label }}</div>
        <div class="FilterElement RoundShadowElement">
            <input :id="ElementID" class="SearchInput" :placeholder="Placeholder" @input="OnInput" @change="OnInputChange"/>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        ElementID: String,
        Label: String,
        Placeholder: String,
        OnChange: Function,
        OnTyping: Function,
    },
    methods:{
        OnInput(event)
        {
            if (this.OnTyping !== null &&
                this.OnTyping !== undefined)
            {
                this.OnTyping(event.target.value);
            }
        },
        OnInputChange(event)
        {
            if (this.OnChange !== null &&
                this.OnChange !== undefined)
            {
                this.OnChange(event.target.value);
            }
        }
    }
}
</script>

<style>
.SearchInput
{
    border: none;
    height: 100%;
    padding: 0px;
    width: 100%;
}
</style>